module.exports = __webpack_public_path__ + "img/shotgun.f8eeaffe.png";